import type { Variant } from '../ProductCardTypes'

export type SKUPriceRange = {
  lowestPrice: number
  highestPrice: number
}

export function getSKUPriceRange(variants: Variant[]): SKUPriceRange | null {
  if (variants?.length <= 1) {
    return null
  }

  const skuPriceRange = {
    lowestPrice: 0,
    highestPrice: 0,
  }

  variants.forEach((variant) => {
    const { offers } = variant?.offers

    const prices = offers
      .filter((offer) => offer?.availability === 'https://schema.org/InStock')
      .map((offer) => offer?.price)

    const maxPrice = Math.max(...prices)
    const minPrice = Math.min(...prices)

    if (
      skuPriceRange.lowestPrice === 0 ||
      minPrice < skuPriceRange.lowestPrice
    ) {
      skuPriceRange.lowestPrice = minPrice
    }

    if (maxPrice > skuPriceRange.highestPrice) {
      skuPriceRange.highestPrice = maxPrice
    }
  })

  if (skuPriceRange.lowestPrice === skuPriceRange.highestPrice) {
    return null
  }

  return skuPriceRange
}
